import React from 'react';
import { usePrototype } from '../../contexts/PrototypeContext';
import { productImages, siteConfig } from '../../data/siteConfig';
import { useAnchorNavigation } from '../../hooks/useAnchorNavigation';
import { buttonClasses } from '../../utils/buttonStyles';
import { formatPrice } from '../../utils/currency';
export function Hero() {
  const {
    seasonConfig
  } = usePrototype();
  const goTo = useAnchorNavigation();
  const {
    product,
    fulfillment
  } = siteConfig;
  const isDark = seasonConfig.id === 'black-friday';
  const titleColor = isDark ? 'text-canvas' : 'text-ink';
  const bodyColor = isDark ? 'text-canvas/80' : 'text-ink-muted';
  const eyebrowColor = isDark ? 'text-champagne' : seasonConfig.accentTextClass;
  const ruleColor = isDark ? 'bg-champagne' : seasonConfig.accentRuleClass;
  return <section data-hero-panel={seasonConfig.id} aria-labelledby="hero-title" className={`overflow-hidden transition-colors duration-200 ease-out ${seasonConfig.heroPanelClass}`} data-id="element-188" data-mp="1v3c3aoi82nbs">
      <div className="mx-auto grid max-w-page items-center gap-5 px-5 pb-8 pt-7 md:grid-cols-[1.04fr_0.96fr] md:gap-6 md:px-10 md:py-14 lg:min-h-[630px] lg:gap-14 lg:py-16" data-id="element-189" data-mp="1mvax5wwzyeds">
      <div className="relative z-10 min-w-0 max-w-xl" data-id="element-190" data-mp="1cyofti3vq5gi">
        <div className="flex items-center gap-3" data-id="element-191" data-mp="1czzi1dhof55i">
          <span aria-hidden="true" className={`h-px w-10 shrink-0 transition-colors duration-200 ${ruleColor}`} data-id="element-192" data-mp="1hwq0u8kv8eum" />
          <p className={`min-w-0 text-[14px] font-medium [overflow-wrap:anywhere] transition-colors duration-200 ${eyebrowColor}`} data-id="element-193" data-mp="25nveqi78wx2a">
            {seasonConfig.heroEyebrow}
          </p>
        </div>
        <h1 id="hero-title" className={`mt-4 font-display text-[42px] font-medium leading-[1.02] tracking-[-0.01em] md:mt-5 md:text-[54px] lg:text-[72px] ${titleColor}`} data-id="element-194" data-mp="1vvzfh3tfb0wh">
          Meet your new skincare ritual.
        </h1>
        <p className={`mt-4 max-w-lg text-[16px] leading-relaxed md:mt-5 md:text-[17px] lg:text-[18px] ${bodyColor}`} data-id="element-195" data-mp="2ojvbe6b64os7">
          A facial light-therapy mask for men and women, with a white silicone design and hands-free voice control.
        </p>
        <div className="mt-6 flex flex-col flex-wrap gap-3 sm:flex-row md:mt-7" data-id="element-196" data-mp="2yadasvzpgkok">
          <a href="/#the-mask" onClick={goTo('the-mask')} className={buttonClasses(isDark ? 'inverse' : 'primary')} data-id="element-197" data-mp="2u773dl0uwngi">
            Shop the mask
          </a>
          <a href="/#details" onClick={goTo('details')} className={buttonClasses(isDark ? 'inverse-outline' : 'secondary')} data-id="element-198" data-mp="2paq6o2fld0rt">
            Explore the details
          </a>
        </div>
        <div className="mt-4 md:mt-6" data-id="element-199" data-mp="2fhhq4rfhoszv">
          <p className={`flex flex-wrap items-baseline gap-x-3 text-[14px] ${bodyColor}`} data-id="element-200" data-mp="2ajg889tsuzpz">
            <span className={`text-xl font-medium tabular-nums ${titleColor}`} data-id="element-201" data-mp="26i4hu233qagq">{formatPrice(product.samplePrice)}</span>
            <span data-id="element-202" data-mp="21jkqtn9ni8hi"><span className="sr-only" data-id="element-203" data-mp="21jb01xgs7xar">Regular price </span><s data-id="element-204" data-mp="21l491jevatlx">{formatPrice(product.regularPrice)}</s></span>
            <span data-id="element-205" data-mp="1wkzptlmkrks0">Available in {product.color}</span>
          </p>
          <p className={`mt-1 text-[13px] leading-relaxed ${bodyColor}`} data-id="element-206" data-mp="c1w7bd4ga7i7">{fulfillment.shippingLabel} · {fulfillment.dispatch}</p>
        </div>
      </div>

      <div className="relative flex min-w-0 justify-center md:justify-end" data-id="element-207" data-mp="gzfoolwg30ed">
          <figure data-hero-art className="relative h-[210px] w-[280px] max-w-full md:h-[390px] md:w-[380px] lg:h-[510px] lg:w-[480px] xl:w-[500px]" data-id="element-208" data-mp="m15228753q5m">
            <span aria-hidden="true" className={`absolute bottom-[6%] left-[20%] h-3 w-[62%] rounded-[50%] blur-md md:h-5 ${isDark ? 'bg-black/40' : 'bg-ink/20'}`} data-id="element-209" data-mp="pzcguxi1mhe6" />
            <img src={productImages.hero.src} alt={productImages.hero.alt} width={productImages.hero.nativeWidth} className="relative z-10 block h-full w-full object-contain" style={{
            filter: 'drop-shadow(0 16px 14px rgba(25, 27, 25, 0.18))'
          }} data-id="element-210" data-mp="2c4cchsfvcd7" />
            <figcaption className="sr-only" data-id="element-211" data-mp="3ar4k5q493o9h">
              Shown in White, the launch color.
            </figcaption>
          </figure>
      </div>
      </div>
    </section>;
}